import { render, staticRenderFns } from "./AppBlankMain.vue?vue&type=template&id=c08d5544&scoped=true"
import script from "./AppBlankMain.vue?vue&type=script&lang=js"
export * from "./AppBlankMain.vue?vue&type=script&lang=js"
import style0 from "./AppBlankMain.vue?vue&type=style&index=0&id=c08d5544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08d5544",
  null
  
)

export default component.exports